import React from "react";
import styles from "./CallToAction.module.css";
import { Container, Row } from "react-bootstrap";

const CallToAction = ({ cta2, cta3,cta4=false, cta5=false,ctaSteve }) => {
  return (
    <>
      {!cta2 && !cta3 && !cta4 && !cta5 && !ctaSteve && (
        <div className={styles.main}>
          <div className={styles.innerCont}>
            <Container>
              <div className={styles.contentCont}>
                <div className={styles.cta}>
                  <img alt="icon" src="/images/cta.png" />
                  <div className={styles.content}>
                    <h2 className="h1_main text-center pb-2">
                      OUR TRUSTED PARTNERS
                    </h2>
                    <a
                      style={{ textDecoration: "none" }}
                      href="tel:905-299-7841"
                    >
                      <button className="button_main">Give Us a Ring</button>
                    </a>
                  </div>
                </div>
                <div className={styles.iconsCont}>
                  <img alt="icon" src="/images/cta1.png" />
                  <img alt="icon" src="/images/cta2.png" />
                  <img alt="icon" src="/images/cta4.png" />
                  <img
                    alt="icon"
                    style={{ width: "80px" }}
                    src="/images/cta5.jpg"
                  />
                </div>
              </div>
            </Container>
          </div>
        </div>
      )}
      {cta2 && (
        <div className={styles.main2}>
          <Container>
            <div className={styles.contentCont2}>
              <h3 className="h2_main">Call Us to Discuss Your Application</h3>
              <h2 className="heading_capital">
                Please call{" "}
                <span style={{ textDecoration: "underline" }}>
                  905 462 6525
                </span>{" "}
              </h2>

              <a href="tel: 905-462-6525">
                <button className="button_main">905 462 6525</button>
              </a>
            </div>
            <div style={{ gap: "10px" }} className={styles.contentCont2}>
              <h2 className="h2_main pt-5">Visit our new location</h2>
              <h4 className="h4_main">
                348 Bronte St., South Unit #21 Milton, Ontario
              </h4>
            </div>
          </Container>
        </div>
      )}
      {cta3 && (
        <div className={styles.main2}>
          <Container>
            <div className={styles.contentCont2}>
              <h3 className="h2_main">OUR COMMERCIAL PROJECTS</h3>
              <h2 className="heading_capital">
                Please call{" "}
                <span style={{ textDecoration: "underline" }}>
                  905 462 6525
                </span>{" "}
                <br />
              </h2>
              {/* <p className="para_main text-center ps-5 pe-5">
                Solar System Installation, Solar Panel Installation, Ecoflow
                System Installation
              </p> */}
              <a href="tel: 905-462-6525">
                <button className="button_main">905 462 6525</button>
              </a>
            </div>
          </Container>
        </div>
      )}
       {cta4 && (
        <div className={styles.main2}>
          <Container>
            <div className={styles.contentCont2}>
              <h3 className="h2_main">Call Us to Discuss Your Application</h3>
              <h2 className="heading_capital">
                Please call{" "}
                <span style={{ textDecoration: "underline" }}>
                  905-299-7841
                </span>{" "}
              </h2>

              <a href="tel:905-299-7841">
                <button className="button_main">905-299-7841</button>
              </a>
            </div>
            {/* <div style={{ gap: "10px" }} className={styles.contentCont2}>
              <h2 className="h2_main pt-5">Visit our new location</h2>
              <h4 className="h4_main">
                348 Bronte St., South Unit #21 Milton, Ontario
              </h4>
            </div> */}
          </Container>
        </div>
      )}
       {cta5 && (
        <div className={styles.main2}>
          <Container>
            <div className={styles.contentCont2}>
              <h3 className="h2_main">{cta5?.heading}</h3>
              <h2 className="heading_capital">
                Please call{" "}
                <span style={{ textDecoration: "underline" }}>
                  905-299-7841
                </span>{" "}
              </h2>

              <a href="tel:905-299-7841">
                <button className="button_main">905-299-7841</button>
              </a>
            </div>
            {/* <div style={{ gap: "10px" }} className={styles.contentCont2}>
              <h2 className="h2_main pt-5">Visit our new location</h2>
              <h4 className="h4_main">
                348 Bronte St., South Unit #21 Milton, Ontario
              </h4>
            </div> */}
          </Container>
        </div>
      )}
       {ctaSteve && (
        <div className={styles.main2}>
          <Container>
            <div className={styles.contentCont2}>
              <h3 className="h2_main">Call Us to Discuss Your Application</h3>
              <h2 className="heading_capital">
                Please call{" "}
                <span style={{ textDecoration: "underline" }}>
                  289-981-7825
                </span>{" "}
              </h2>

              <a href="tel: 289-981-7825">
                <button className="button_main">289-981-7825</button>
              </a>
            </div>
            {/* <div style={{ gap: "10px" }} className={styles.contentCont2}>
              <h2 className="h2_main pt-5">Visit our new location</h2>
              <h4 className="h4_main">
                348 Bronte St., South Unit #21 Milton, Ontario
              </h4>
            </div> */}
          </Container>
        </div>
      )}
    </>
  );
};

export default CallToAction;
